<script setup lang="ts">
import { MaybeRef } from 'vue'
import { defaultUrls } from '../../../stores/config'
import { EndpointResponse } from '../../../types/base'
import PejerDonutChart from '../PejerDonutChart.vue'
defineProps<{
  data: MaybeRef<EndpointResponse<(typeof defaultUrls)['connectedAccounts']['stats']>>
  horizontal?: boolean
}>()
</script>
<template>
  <PejerDonutChart
    :data="data"
    :horizontal="horizontal"
    title="Payout Status"
    :data-options="[
      { key: 'payoutsEnabledCount', name: 'Payouts enabled', color: '#13b982' },
      { key: 'payoutsDisabledCount', name: 'Payouts disabled', color: '#FF9999' },
    ]"
  />
</template>
